(() => {
  const ATTRIBUTE_KEY = '紹介者コード';
  const SELECTOR = '[data-partner-referral-input]';
  const ERROR_SELECTOR = '[data-partner-referral-error]';
  const CODE_PATTERN = /^YAT-P\d{4}$/;
  let urlReferralCode = '';
  let checkoutSubmitInProgress = false;
  let cartAddSubmitInProgress = false;

  const cleanCode = (value) => {
    if (!value) return '';
    return String(value).trim().replace(/[^a-zA-Z0-9-]/g, '').slice(0, 9).toUpperCase();
  };

  const isValidCode = (code) => CODE_PATTERN.test(code);

  const getErrorElement = (input) => {
    const wrapper = input && input.closest('.cart-referral-code');
    return wrapper && wrapper.querySelector(ERROR_SELECTOR);
  };

  const setInputError = (input, hasError) => {
    if (!input) return;

    const error = getErrorElement(input);
    input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
    input.classList.toggle('cart-referral-code__input--error', hasError);

    if (error) {
      error.hidden = !hasError;
      error.setAttribute('aria-hidden', hasError ? 'false' : 'true');
    }
  };

  const normalizeInput = (input) => {
    if (!input) return '';
    const code = cleanCode(input.value);
    if (input.value !== code) input.value = code;
    return code;
  };

  const validateInput = (input, showError = false) => {
    const code = normalizeInput(input);
    const hasError = Boolean(code && !isValidCode(code));
    if (showError || !hasError) setInputError(input, hasError);
    return hasError ? null : code;
  };

  const getRefFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return cleanCode(params.get('ref') || params.get('partner_ref') || params.get('referral_code'));
  };

  const updateCartAttribute = (code) => {
    if (!window.routes || !window.routes.cart_update_url) return Promise.resolve();

    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTRIBUTE_KEY]: code } }),
    }).catch(() => {});
  };

  const syncInputs = (code, expand = false) => {
    if (!code) return;
    document.querySelectorAll(SELECTOR).forEach((input) => {
      if (!input.value) input.value = code;
      setInputError(input, false);
      if (expand) {
        const details = input.closest('details');
        if (details) details.open = true;
      }
    });
  };

  const init = () => {
    const urlRef = getRefFromUrl();
    if (urlRef && isValidCode(urlRef)) {
      urlReferralCode = urlRef;
      updateCartAttribute(urlRef);
      syncInputs(urlRef, true);
    }

    document.querySelectorAll(SELECTOR).forEach((input) => {
      const currentCode = cleanCode(input.value);
      if (currentCode && !isValidCode(currentCode)) {
        input.value = currentCode;
        setInputError(input, true);
        updateCartAttribute('');
      }

      if (input.dataset.partnerReferralBound === 'true') return;
      input.dataset.partnerReferralBound = 'true';
      input.addEventListener('input', () => {
        normalizeInput(input);
        setInputError(input, false);
      });
      input.addEventListener('blur', () => {
        const code = validateInput(input, true);
        if (code) {
          urlReferralCode = code;
          syncInputs(code, false);
        }
      });
      input.addEventListener('invalid', (event) => {
        event.preventDefault();
        validateInput(input, true);
        const details = input.closest('details');
        if (details) details.open = true;
        input.focus();
      });
    });
  };

  const submitCheckoutForm = (form, submitter) => {
    checkoutSubmitInProgress = true;

    if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = submitter && submitter.value ? submitter.value : '';
      form.appendChild(checkoutInput);
    }

    HTMLFormElement.prototype.submit.call(form);
  };

  const submitCartAddForm = (form) => {
    cartAddSubmitInProgress = true;
    HTMLFormElement.prototype.submit.call(form);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form) return;

    const isCheckoutForm = form.querySelector('[name="checkout"]');
    const isCartAddForm = form.action && form.action.indexOf('/cart/add') !== -1;

    if (isCartAddForm && urlReferralCode && isValidCode(urlReferralCode) && !cartAddSubmitInProgress) {
      event.preventDefault();
      await updateCartAttribute(urlReferralCode);
      submitCartAddForm(form);
      return;
    }

    if (!isCheckoutForm) return;
    if (checkoutSubmitInProgress) return;

    event.preventDefault();

    const input = form.querySelector(SELECTOR) || document.querySelector(SELECTOR);
    const inputCode = input ? validateInput(input, true) : '';
    if (input && input.value && !inputCode) {
      const details = input.closest('details');
      if (details) details.open = true;
      input.focus();
      return;
    }

    const code = cleanCode(inputCode || urlReferralCode);
    const submitter = event.submitter || form.querySelector('[name="checkout"]');

    if (!code || !isValidCode(code)) {
      if (input) input.value = '';
      await updateCartAttribute('');
      submitCheckoutForm(form, submitter);
      return;
    }

    if (input) input.value = code;
    urlReferralCode = code;
    syncInputs(code, false);
    await updateCartAttribute(code);
    submitCheckoutForm(form, submitter);
  }, true);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:updated', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('cart-drawer, .cart__footer-wrapper')) return;
    window.setTimeout(init, 0);
  });
})();
